
export enum AmPm {
  AM = 0,
  PM=1
}

export const AmPmToString:  {[key in AmPm]: string}  = {
  [AmPm.AM]: 'AM',
  [AmPm.PM]: 'PM',
};
